import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { List } from 'immutable';
import { Client, Communication } from 'src/app/models';
import { ClientService } from 'src/app/services';
import { ClientCommunicationHistoryComponent } from './client-communication-history/client-communication-history.component';
import { UserService } from 'src/app/services';

@Component({
  selector: 'smr-client-communication-history-list',
  templateUrl: './client-communication-history-list.component.html',
  styleUrls: ['./client-communication-history-list.component.scss']
})
export class ClientCommunicationHistoryListComponent implements OnInit, OnChanges {
  @Input() client: Client;

  @Output() communicationSelect = new EventEmitter<Communication>();

  public isLoadingCommunications: boolean;

  public errorOccurredWhileLoadingCommunicationHistory: boolean;

  public communications: List<Communication>;
  public loadingCommunications = false;

  public page: number;

  public pageSize: number;

  public communicationsFullyLoaded: boolean;

  constructor(
    private clientService: ClientService,
    private modalController: ModalController,
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService
  ) {
    this.page = 1;
    this.page = 30;
    this.communicationsFullyLoaded = false;
    this.communications = List([]);
  }

  public ngOnInit() {
    this.loadCommunications();
  }

  public ngOnChanges(changes: SimpleChanges) {

    if(changes.client){
      this.communications = List([]);
      this.loadCommunications();
    }
  }

  public loadCommunications(infiniteScroll = null) {
    if (this.loadingCommunications) {
      return; 
    }
  
    this.loadingCommunications = true;
    if (!infiniteScroll) {
      this.isLoadingCommunications = true;
      this.errorOccurredWhileLoadingCommunicationHistory = false;
    }

    this.clientService.getCommunicationHistory(this.client,this.userService.getSalon().getId()).subscribe({
      next: (communications) => {
        if (communications.count() < this.pageSize) {
          this.communicationsFullyLoaded = true;
        }

        this.page = this.page + 1;
        this.communications = this.communications.push(
          ...communications.toJSON()
        );
        this.changeDetectorRef.markForCheck();

        if (infiniteScroll) {
          infiniteScroll.complete();
        } else {
          this.isLoadingCommunications = false;
        }
      },
      error: (err) => {
        if (infiniteScroll) {
          infiniteScroll.complete();
        } else {
          this.isLoadingCommunications = false;
          this.errorOccurredWhileLoadingCommunicationHistory = true;
        }

        this.changeDetectorRef.markForCheck();
      }}
    );
  }

  public async onCommunicationView(communication: Communication) {
    const modal = await this.modalController.create(
      {
        component: ClientCommunicationHistoryComponent,
        componentProps: {
          communication: communication,
          client: this.client
        }
    });
    modal.onWillDismiss().then((data) => {
      if (data.data) {
        this.communications = this.communications.unshift(data.data);
        this.changeDetectorRef.markForCheck();
      }
    });
    modal.present();
  }
}
